import {commit, make} from 'vuex-pathify'

// initial state
function defaultState() {
    return {
        version: null,
        form_token: null,
        completion: 'incomplete',
        match_token: null,
        country:null,
        lang:null,
        id_privacy: null,

        current_step: null,

        steps_track: [],
        steps_log: [],
        // full_url: null,

        created_at_front: window.DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
        updated_at_front: window.DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),

        device: null,

        channel: null,
        sms_verified: false,
        sms_send: false,
        sms_retry_number: 0,

        sms_link: null,

        part_1_complete: false,

        is_dirty:false,

        query_string:{},

        is_test:0,

        session_uuid:null,
    }
}

const state = defaultState();

// getters
const getters = {
    defaultState : (state) => {
        return defaultState();
    },
    isMobile: (state) => {
        return state.device=='tablet' || state.device=='mobile';
    },
    isDesktop: (state, getters)=>{
        return !getters.isMobile;
    }
}

// actions
const actions = {}

// mutations
const mutations = {
    ...make.mutations(state),
    resetState(state) {
        const initial = defaultState();
        let keysState = _.keys(state);
        let keysInitial = _.keys(initial);
        let keysDifference = _.difference(keysState,keysInitial);
        Object.keys(initial).forEach(key => {
            state[key] = initial[key]
        })
        _.forEach(keysDifference,item=>{_.unset(state,item)})
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
